import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createSlots as _createSlots, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "page-wrap" }
const _hoisted_2 = {
  key: 0,
  class: "mb-3 grid max-w-sm grid-cols-1 gap-2"
}
const _hoisted_3 = ["value"]
const _hoisted_4 = { class: "category-table-block" }
const _hoisted_5 = {
  key: 0,
  class: "table-loading-overlay"
}
const _hoisted_6 = { class: "data-table category-data-table" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = ["colspan"]
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { class: "inline-flex w-max gap-2" }
const _hoisted_12 = { class: "mb-4 flex items-start justify-between" }
const _hoisted_13 = { class: "text-xl font-bold text-ink" }
const _hoisted_14 = { class: "text-sm text-slate-500" }
const _hoisted_15 = {
  key: 0,
  class: "grid gap-3 md:grid-cols-2"
}
const _hoisted_16 = ["value"]
const _hoisted_17 = { class: "mt-4 flex justify-end gap-3" }
const _hoisted_18 = { class: "mb-4 flex items-start justify-between" }
const _hoisted_19 = { class: "text-xl font-bold text-ink" }
const _hoisted_20 = { class: "text-sm text-slate-500" }
const _hoisted_21 = { class: "text-sm font-semibold text-slate-600" }
const _hoisted_22 = { class: "font-bold text-ink" }
const _hoisted_23 = { class: "mt-4 flex justify-end gap-3" }
const _hoisted_24 = { class: "mb-4 flex items-start justify-between" }
const _hoisted_25 = { class: "text-sm text-slate-500" }
const _hoisted_26 = { class: "mt-4 flex justify-end gap-3" }
const _hoisted_27 = { class: "mb-4 flex items-start justify-between" }
const _hoisted_28 = { class: "text-sm text-slate-500" }
const _hoisted_29 = { class: "mt-4 flex justify-end gap-3" }
const _hoisted_30 = { class: "mb-4 flex items-start justify-between" }
const _hoisted_31 = { class: "text-sm text-slate-500" }
const _hoisted_32 = { class: "grid gap-3 md:grid-cols-2" }
const _hoisted_33 = ["value"]
const _hoisted_34 = { class: "mt-4 flex justify-end gap-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UiButton = _resolveComponent("UiButton")!
  const _component_UiPageHero = _resolveComponent("UiPageHero")!
  const _component_UiSelect = _resolveComponent("UiSelect")!
  const _component_UiPagination = _resolveComponent("UiPagination")!
  const _component_UiPanel = _resolveComponent("UiPanel")!
  const _component_UiInput = _resolveComponent("UiInput")!
  const _component_UiModal = _resolveComponent("UiModal")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createVNode(_component_UiPageHero, {
      eyebrow: "Quản lý danh mục",
      title: $setup.config.title,
      description: $setup.config.description
    }, _createSlots({ _: 2 }, [
      ($setup.canManageCurrentCategory)
        ? {
            name: "actions",
            fn: _withCtx(() => [
              _createVNode(_component_UiButton, {
                variant: "white",
                icon: "add",
                onClick: $setup.openCreateCategory
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString($setup.createButtonLabel), 1)
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            key: "0"
          }
        : undefined
    ]), 1032, ["title", "description"]),
    _createVNode(_component_UiPanel, null, {
      default: _withCtx(() => [
        ($setup.category === 'device-type-details')
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_component_UiSelect, {
                modelValue: $setup.selectedGroupId,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.selectedGroupId) = $event)),
                modelModifiers: { number: true },
                label: "Nhóm thiết bị"
              }, {
                default: _withCtx(() => [
                  _cache[18] || (_cache[18] = _createElementVNode("option", { value: 0 }, "Chọn nhóm thiết bị", -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.groups, (item) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: item.id,
                      value: item.id
                    }, _toDisplayString(item.tenNhomThietBi), 9, _hoisted_3))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", {
            class: _normalizeClass([
            'table-wrap category-table-wrap',
            $setup.loading ? 'is-loading' : '',
          ])
          }, [
            ($setup.loading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [...(_cache[19] || (_cache[19] = [
                  _createElementVNode("span", { class: "table-spinner" }, null, -1),
                  _createTextVNode(" Đang tải dữ liệu... ", -1)
                ]))]))
              : _createCommentVNode("", true),
            _createElementVNode("table", _hoisted_6, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.config.columns, (column) => {
                    return (_openBlock(), _createElementBlock("th", {
                      key: column.key
                    }, _toDisplayString(column.label), 1))
                  }), 128)),
                  ($setup.hasRowActions)
                    ? (_openBlock(), _createElementBlock("th", _hoisted_7, "Thao tác"))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("tbody", null, [
                (!$setup.rows.length && !$setup.loading)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_8, [
                      _createElementVNode("td", {
                        colspan: $setup.tableColspan,
                        class: "text-center"
                      }, " Không có dữ liệu ", 8, _hoisted_9)
                    ]))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.paginatedRows, (row, index) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: row.id
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.config.columns, (column) => {
                      return (_openBlock(), _createElementBlock("td", {
                        key: column.key
                      }, _toDisplayString(column.key === "id"
                      ? $setup.rowIndex(index)
                      : $setup.formatValue(row[column.key])), 1))
                    }), 128)),
                    ($setup.hasRowActions)
                      ? (_openBlock(), _createElementBlock("td", _hoisted_10, [
                          _createElementVNode("div", _hoisted_11, [
                            ($setup.category === 'departments')
                              ? (_openBlock(), _createBlock(_component_UiButton, {
                                  key: 0,
                                  type: "button",
                                  variant: "secondary",
                                  size: "sm",
                                  icon: "edit",
                                  onClick: ($event: any) => ($setup.openUpdateDepartment(row))
                                }, {
                                  default: _withCtx(() => [...(_cache[20] || (_cache[20] = [
                                    _createTextVNode(" Cập nhật ", -1)
                                  ]))]),
                                  _: 1
                                }, 8, ["onClick"]))
                              : _createCommentVNode("", true),
                            ($setup.category === 'device-groups')
                              ? (_openBlock(), _createBlock(_component_UiButton, {
                                  key: 1,
                                  type: "button",
                                  variant: "secondary",
                                  size: "sm",
                                  icon: "edit",
                                  onClick: ($event: any) => ($setup.openUpdateDeviceGroup(row))
                                }, {
                                  default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
                                    _createTextVNode(" Cập nhật ", -1)
                                  ]))]),
                                  _: 1
                                }, 8, ["onClick"]))
                              : _createCommentVNode("", true),
                            ($setup.category === 'device-type-details')
                              ? (_openBlock(), _createBlock(_component_UiButton, {
                                  key: 2,
                                  type: "button",
                                  variant: "secondary",
                                  size: "sm",
                                  icon: "edit",
                                  onClick: ($event: any) => ($setup.openUpdateDeviceType(row))
                                }, {
                                  default: _withCtx(() => [...(_cache[22] || (_cache[22] = [
                                    _createTextVNode(" Cập nhật ", -1)
                                  ]))]),
                                  _: 1
                                }, 8, ["onClick"]))
                              : _createCommentVNode("", true),
                            ($setup.canDeleteCurrentCategory)
                              ? (_openBlock(), _createBlock(_component_UiButton, {
                                  key: 3,
                                  type: "button",
                                  variant: "danger",
                                  size: "sm",
                                  icon: "delete",
                                  onClick: ($event: any) => ($setup.openDeleteCategory(row))
                                }, {
                                  default: _withCtx(() => [...(_cache[23] || (_cache[23] = [
                                    _createTextVNode(" Xóa ", -1)
                                  ]))]),
                                  _: 1
                                }, 8, ["onClick"]))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ])
            ])
          ], 2),
          _createVNode(_component_UiPagination, {
            modelValue: $setup.page,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.page) = $event)),
            total: $setup.rows.length,
            "page-size": $setup.pageSize
          }, null, 8, ["modelValue", "total", "page-size"])
        ])
      ]),
      _: 1
    }),
    ($setup.showCreateModal)
      ? (_openBlock(), _createBlock(_component_UiModal, { key: 0 }, {
          default: _withCtx(() => [
            _createElementVNode("form", {
              onSubmit: _cache[7] || (_cache[7] = _withModifiers(
//@ts-ignore
(...args) => ($setup.createCategory && $setup.createCategory(...args)), ["prevent"]))
            }, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", null, [
                  _createElementVNode("p", _hoisted_13, _toDisplayString($setup.createModalTitle), 1),
                  _createElementVNode("p", _hoisted_14, _toDisplayString($setup.createModalDescription), 1)
                ]),
                _createVNode(_component_UiButton, {
                  variant: "ghost",
                  size: "sm",
                  icon: "close",
                  onClick: $setup.closeCreateCategory
                }, {
                  default: _withCtx(() => [...(_cache[24] || (_cache[24] = [
                    _createTextVNode(" Đóng ", -1)
                  ]))]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              ($setup.category === 'device-type-details')
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    _createVNode(_component_UiInput, {
                      modelValue: $setup.deviceTypeForm.tenLoaiThietBi,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.deviceTypeForm.tenLoaiThietBi) = $event)),
                      class: "md:col-span-2",
                      label: "Tên loại thiết bị",
                      required: "",
                      placeholder: "Nhập tên loại thiết bị"
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_UiInput, {
                      modelValue: $setup.deviceTypeForm.thoiGianHaoMon,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.deviceTypeForm.thoiGianHaoMon) = $event)),
                      modelModifiers: { number: true },
                      label: "Thời gian hao mòn",
                      type: "number",
                      min: "0",
                      required: "",
                      placeholder: "Nhập thời gian hao mòn"
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_UiInput, {
                      modelValue: $setup.deviceTypeForm.tyLeHaoMon,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.deviceTypeForm.tyLeHaoMon) = $event)),
                      modelModifiers: { number: true },
                      label: "Tỷ lệ hao mòn",
                      type: "number",
                      min: "0",
                      step: "0.01",
                      required: "",
                      placeholder: "Nhập tỷ lệ hao mòn"
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_UiSelect, {
                      modelValue: $setup.deviceTypeForm.idNhomThietBi,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.deviceTypeForm.idNhomThietBi) = $event)),
                      modelModifiers: { number: true },
                      class: "md:col-span-2",
                      label: "Nhóm thiết bị",
                      required: ""
                    }, {
                      default: _withCtx(() => [
                        _cache[25] || (_cache[25] = _createElementVNode("option", { value: 0 }, "Chọn nhóm thiết bị", -1)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.groups, (item) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: item.id,
                            value: item.id
                          }, _toDisplayString(item.tenNhomThietBi), 9, _hoisted_16))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]))
                : (_openBlock(), _createBlock(_component_UiInput, {
                    key: 1,
                    modelValue: $setup.categoryForm.name,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.categoryForm.name) = $event)),
                    label: $setup.formFieldLabel,
                    required: "",
                    placeholder: $setup.formFieldPlaceholder
                  }, null, 8, ["modelValue", "label", "placeholder"])),
              _createElementVNode("div", _hoisted_17, [
                _createVNode(_component_UiButton, {
                  type: "button",
                  variant: "secondary",
                  icon: "cancel",
                  onClick: $setup.closeCreateCategory
                }, {
                  default: _withCtx(() => [...(_cache[26] || (_cache[26] = [
                    _createTextVNode(" Hủy ", -1)
                  ]))]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_UiButton, {
                  type: "submit",
                  icon: "confirm",
                  loading: $setup.creatingCategory
                }, {
                  default: _withCtx(() => [...(_cache[27] || (_cache[27] = [
                    _createTextVNode(" Xác nhận ", -1)
                  ]))]),
                  _: 1
                }, 8, ["loading"])
              ])
            ], 32)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    ($setup.categoryToDelete)
      ? (_openBlock(), _createBlock(_component_UiModal, { key: 1 }, {
          default: _withCtx(() => [
            _createElementVNode("form", {
              onSubmit: _cache[8] || (_cache[8] = _withModifiers(
//@ts-ignore
(...args) => ($setup.deleteCategory && $setup.deleteCategory(...args)), ["prevent"]))
            }, [
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", null, [
                  _createElementVNode("p", _hoisted_19, _toDisplayString($setup.deleteModalTitle), 1),
                  _createElementVNode("p", _hoisted_20, _toDisplayString($setup.categoryDeleteName), 1)
                ]),
                _createVNode(_component_UiButton, {
                  variant: "ghost",
                  size: "sm",
                  icon: "close",
                  onClick: $setup.closeDeleteCategory
                }, {
                  default: _withCtx(() => [...(_cache[28] || (_cache[28] = [
                    _createTextVNode(" Đóng ", -1)
                  ]))]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _createElementVNode("p", _hoisted_21, [
                _createTextVNode(" Bạn có chắc chắn muốn xóa " + _toDisplayString($setup.currentItemLabel) + " ", 1),
                _createElementVNode("span", _hoisted_22, _toDisplayString($setup.categoryDeleteName), 1),
                _cache[29] || (_cache[29] = _createTextVNode(" không? ", -1))
              ]),
              _createElementVNode("div", _hoisted_23, [
                _createVNode(_component_UiButton, {
                  type: "button",
                  variant: "secondary",
                  icon: "cancel",
                  onClick: $setup.closeDeleteCategory
                }, {
                  default: _withCtx(() => [...(_cache[30] || (_cache[30] = [
                    _createTextVNode(" Hủy ", -1)
                  ]))]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_UiButton, {
                  type: "submit",
                  variant: "danger",
                  icon: "delete",
                  loading: $setup.deletingCategory
                }, {
                  default: _withCtx(() => [...(_cache[31] || (_cache[31] = [
                    _createTextVNode(" Xác nhận xóa ", -1)
                  ]))]),
                  _: 1
                }, 8, ["loading"])
              ])
            ], 32)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    ($setup.departmentToUpdate)
      ? (_openBlock(), _createBlock(_component_UiModal, { key: 2 }, {
          default: _withCtx(() => [
            _createElementVNode("form", {
              onSubmit: _cache[10] || (_cache[10] = _withModifiers(
//@ts-ignore
(...args) => ($setup.updateDepartment && $setup.updateDepartment(...args)), ["prevent"]))
            }, [
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("div", null, [
                  _cache[32] || (_cache[32] = _createElementVNode("p", { class: "text-xl font-bold text-ink" }, "Cập nhật khoa phòng", -1)),
                  _createElementVNode("p", _hoisted_25, _toDisplayString($setup.departmentToUpdate.tenKhoaPhong), 1)
                ]),
                _createVNode(_component_UiButton, {
                  variant: "ghost",
                  size: "sm",
                  icon: "close",
                  onClick: $setup.closeUpdateDepartment
                }, {
                  default: _withCtx(() => [...(_cache[33] || (_cache[33] = [
                    _createTextVNode(" Đóng ", -1)
                  ]))]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _createVNode(_component_UiInput, {
                modelValue: $setup.departmentUpdateForm.tenKhoaPhong,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (($setup.departmentUpdateForm.tenKhoaPhong) = $event)),
                label: "Tên khoa phòng",
                required: "",
                placeholder: "Nhập tên khoa phòng"
              }, null, 8, ["modelValue"]),
              _createElementVNode("div", _hoisted_26, [
                _createVNode(_component_UiButton, {
                  type: "button",
                  variant: "secondary",
                  icon: "cancel",
                  onClick: $setup.closeUpdateDepartment
                }, {
                  default: _withCtx(() => [...(_cache[34] || (_cache[34] = [
                    _createTextVNode(" Hủy ", -1)
                  ]))]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_UiButton, {
                  type: "submit",
                  icon: "save",
                  loading: $setup.updatingDepartment
                }, {
                  default: _withCtx(() => [...(_cache[35] || (_cache[35] = [
                    _createTextVNode(" Xác nhận ", -1)
                  ]))]),
                  _: 1
                }, 8, ["loading"])
              ])
            ], 32)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    ($setup.deviceGroupToUpdate)
      ? (_openBlock(), _createBlock(_component_UiModal, { key: 3 }, {
          default: _withCtx(() => [
            _createElementVNode("form", {
              onSubmit: _cache[12] || (_cache[12] = _withModifiers(
//@ts-ignore
(...args) => ($setup.updateDeviceGroup && $setup.updateDeviceGroup(...args)), ["prevent"]))
            }, [
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("div", null, [
                  _cache[36] || (_cache[36] = _createElementVNode("p", { class: "text-xl font-bold text-ink" }, "Cập nhật nhóm thiết bị", -1)),
                  _createElementVNode("p", _hoisted_28, _toDisplayString($setup.deviceGroupToUpdate.tenNhomThietBi), 1)
                ]),
                _createVNode(_component_UiButton, {
                  variant: "ghost",
                  size: "sm",
                  icon: "close",
                  onClick: $setup.closeUpdateDeviceGroup
                }, {
                  default: _withCtx(() => [...(_cache[37] || (_cache[37] = [
                    _createTextVNode(" Đóng ", -1)
                  ]))]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _createVNode(_component_UiInput, {
                modelValue: $setup.deviceGroupUpdateForm.tenNhomThietBi,
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (($setup.deviceGroupUpdateForm.tenNhomThietBi) = $event)),
                label: "Tên nhóm thiết bị",
                required: "",
                placeholder: "Nhập tên nhóm thiết bị"
              }, null, 8, ["modelValue"]),
              _createElementVNode("div", _hoisted_29, [
                _createVNode(_component_UiButton, {
                  type: "button",
                  variant: "secondary",
                  icon: "cancel",
                  onClick: $setup.closeUpdateDeviceGroup
                }, {
                  default: _withCtx(() => [...(_cache[38] || (_cache[38] = [
                    _createTextVNode(" Hủy ", -1)
                  ]))]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_UiButton, {
                  type: "submit",
                  icon: "save",
                  loading: $setup.updatingDeviceGroup
                }, {
                  default: _withCtx(() => [...(_cache[39] || (_cache[39] = [
                    _createTextVNode(" Xác nhận ", -1)
                  ]))]),
                  _: 1
                }, 8, ["loading"])
              ])
            ], 32)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    ($setup.deviceTypeToUpdate)
      ? (_openBlock(), _createBlock(_component_UiModal, { key: 4 }, {
          default: _withCtx(() => [
            _createElementVNode("form", {
              onSubmit: _cache[17] || (_cache[17] = _withModifiers(
//@ts-ignore
(...args) => ($setup.updateDeviceType && $setup.updateDeviceType(...args)), ["prevent"]))
            }, [
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("div", null, [
                  _cache[40] || (_cache[40] = _createElementVNode("p", { class: "text-xl font-bold text-ink" }, " Cập nhật chi tiết loại thiết bị ", -1)),
                  _createElementVNode("p", _hoisted_31, _toDisplayString($setup.deviceTypeToUpdate.tenLoaiThietBi), 1)
                ]),
                _createVNode(_component_UiButton, {
                  variant: "ghost",
                  size: "sm",
                  icon: "close",
                  onClick: $setup.closeUpdateDeviceType
                }, {
                  default: _withCtx(() => [...(_cache[41] || (_cache[41] = [
                    _createTextVNode(" Đóng ", -1)
                  ]))]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _createElementVNode("div", _hoisted_32, [
                _createVNode(_component_UiInput, {
                  modelValue: $setup.deviceTypeUpdateForm.tenLoaiThietBi,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (($setup.deviceTypeUpdateForm.tenLoaiThietBi) = $event)),
                  class: "md:col-span-2",
                  label: "Tên loại thiết bị",
                  required: "",
                  placeholder: "Nhập tên loại thiết bị"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_UiInput, {
                  modelValue: $setup.deviceTypeUpdateForm.thoiGianHaoMon,
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (($setup.deviceTypeUpdateForm.thoiGianHaoMon) = $event)),
                  modelModifiers: { number: true },
                  label: "Thời gian hao mòn",
                  type: "number",
                  min: "0",
                  required: "",
                  placeholder: "Nhập thời gian hao mòn"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_UiInput, {
                  modelValue: $setup.deviceTypeUpdateForm.tyLeHaoMon,
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (($setup.deviceTypeUpdateForm.tyLeHaoMon) = $event)),
                  modelModifiers: { number: true },
                  label: "Tỷ lệ hao mòn",
                  type: "number",
                  min: "0",
                  step: "0.01",
                  required: "",
                  placeholder: "Nhập tỷ lệ hao mòn"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_UiSelect, {
                  modelValue: $setup.deviceTypeUpdateForm.idNhomThietBi,
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (($setup.deviceTypeUpdateForm.idNhomThietBi) = $event)),
                  modelModifiers: { number: true },
                  class: "md:col-span-2",
                  label: "Nhóm thiết bị",
                  required: ""
                }, {
                  default: _withCtx(() => [
                    _cache[42] || (_cache[42] = _createElementVNode("option", { value: 0 }, "Chọn nhóm thiết bị", -1)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.groups, (item) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: item.id,
                        value: item.id
                      }, _toDisplayString(item.tenNhomThietBi), 9, _hoisted_33))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_34, [
                _createVNode(_component_UiButton, {
                  type: "button",
                  variant: "secondary",
                  icon: "cancel",
                  onClick: $setup.closeUpdateDeviceType
                }, {
                  default: _withCtx(() => [...(_cache[43] || (_cache[43] = [
                    _createTextVNode(" Hủy ", -1)
                  ]))]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_UiButton, {
                  type: "submit",
                  icon: "save",
                  loading: $setup.updatingDeviceType
                }, {
                  default: _withCtx(() => [...(_cache[44] || (_cache[44] = [
                    _createTextVNode(" Xác nhận ", -1)
                  ]))]),
                  _: 1
                }, 8, ["loading"])
              ])
            ], 32)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}